import { Table } from "antd";
import { useMemo } from "react";
export default ({
  dataSource,
  loading,
  handleTableChange
}) => {
  const columns = [
    { title: '类别编码', dataIndex: 'categoryCode', key: 'categoryCode' },
    { title: '类别名称', dataIndex: 'categoryName', key: 'categoryName' },
    { title: '上级类别编码', dataIndex: 'parentCode', key: 'parentCode' },
    { title: '上级类别名称', dataIndex: 'parentName', key: 'parentName' },
  ];
  const { list, pageIndex, total, pageSize } = useMemo(() => {
    return {
      list: dataSource.result || [],
      pageIndex: dataSource.pageIndex || 1,
      total: dataSource.recordCount || 0,
      pageSize: dataSource.pageSize || 10
    }
  }, [dataSource])
  return (
    <Table
      rowKey={record=>record.categoryCode}
      dataSource={list}
      loading={loading}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        position: ['bottomLeft'],
        current: pageIndex,
        pageSize: pageSize,
        total: total,
      }}
      columns={columns}
      onChange={(pagination)=>handleTableChange({
        pageIndex: pagination.current,
        pageSize: pagination.pageSize
      })}
    />
  )
}